const filters = {
  workerTitle: 'Trouver des talents',
  description: 'Sélectionnez les expertises marketing de votre choix et découvrez les Talents M experts dans leur domaine!',
  selectMineButtonLabel: 'Cocher mes compétences',
  unselectAllButtonLabel: 'Décocher la sélection',
  noWorkerFound: '🧐 Nous n\'avons trouvé aucun talent correspondant à ta recherche. Si tu connais quelqu\'un qui peut correspondre, propose-lui de rejoindre les Talents M!',
};

export default filters;
